const TextSpacer = () => {
  return <div className="w-full flex h-2" />;
};

export default TextSpacer;
